import 'react-app-polyfill/stable';

import React from 'react'
import ReactDOM from 'react-dom'
import { I18nextProvider } from 'react-i18next'

import '../node_modules/eleneo-react-commons/build/css/index.css'
import './assets/css/index.sass'

import * as env from './helpers/env'
import { i18n, init } from 'commons'

import App from './App'
import registerServiceWorker from './registerServiceWorker'
import configureStore from './configureStore'

import fr from './locales/fr.json'
import en from './locales/en.json'

init(env)

i18n.addResourceBundle('fr', 'translation', fr);
i18n.addResourceBundle('en', 'translation', en);


ReactDOM.render(  
  <I18nextProvider i18n={i18n}>
    <App store={configureStore()} />
  </I18nextProvider>,
  document.getElementById('root')
);

registerServiceWorker();
